module.exports = __webpack_public_path__ + "img/del_fail.91535424.png";